import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { DEFAULT_OG_IMAGE, getSeoForPath, SITE_NAME } from 'config/seo.config';

const SEO = () => {
  const { pathname } = useLocation();
  const { title, description, ogDescription, canonical } =
    getSeoForPath(pathname);
  const openGraphDescription = ogDescription ?? description;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <link rel='canonical' href={canonical} />

      <meta property='og:type' content='website' />
      <meta property='og:site_name' content={SITE_NAME} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={openGraphDescription} />
      <meta property='og:url' content={canonical} />
      <meta property='og:image' content={DEFAULT_OG_IMAGE} />
      <meta property='og:locale' content='ko_KR' />

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={DEFAULT_OG_IMAGE} />
    </Helmet>
  );
};

export default SEO;
